import { render, staticRenderFns } from "./FormStatusNew.vue?vue&type=template&id=0a380843&"
import script from "./FormStatusNew.vue?vue&type=script&lang=js&"
export * from "./FormStatusNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports